import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const ExpandIcon = (props: IconProps) => {
  const { color = FORTA_BLUE.primary } = props;
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.16667 0.5C7.62692 0.5 8 0.8731 8 1.33333C8 1.76069 7.67831 2.11292 7.26385 2.16106L7.16667 2.16667H2.16667V13.8333H13.8333V8.83333C13.8333 8.37308 14.2064 8 14.6667 8C15.094 8 15.4463 8.32169 15.4944 8.73615L15.5 8.83333V13.8333C15.5 14.712 14.8201 15.4318 13.9577 15.4954L13.8333 15.5H2.16667C1.28803 15.5 0.568196 14.8201 0.504571 13.9577L0.5 13.8333V2.16667C0.5 1.28803 1.1799 0.568196 2.04228 0.504571L2.16667 0.5H7.16667ZM14.4583 0.5C15.0337 0.5 15.5 0.966367 15.5 1.54167V4.66667C15.5 5.1269 15.1269 5.5 14.6667 5.5C14.2064 5.5 13.8333 5.1269 13.8333 4.66667V3.34517L8.34517 8.83333H9.66667C10.1269 8.83333 10.5 9.20642 10.5 9.66667C10.5 10.1269 10.1269 10.5 9.66667 10.5H6.54167C5.96637 10.5 5.5 10.0337 5.5 9.45833V6.33333C5.5 5.8731 5.8731 5.5 6.33333 5.5C6.79358 5.5 7.16667 5.8731 7.16667 6.33333V7.65483L12.6548 2.16667H11.3333C10.8731 2.16667 10.5 1.79357 10.5 1.33333C10.5 0.8731 10.8731 0.5 11.3333 0.5H14.4583Z"
        fill={color}
      />
    </svg>
  );
};

export default ExpandIcon;
